import { createSelector } from '@reduxjs/toolkit';
import { selectContract, selectDealType, selectOfferType, selectOfficeTypes } from 'shared/selectors/jsonQuery';
import { EContractType } from '../../../../packages/api-models/common/json_query';
import { getContractFields } from '../../../../packages/JsonQuery/utils/getContractFields';

const LABELS: Record<EContractType, string> = {
  [EContractType.DirectRent]: 'Прямая аренда',
  [EContractType.SubRent]: 'Субаренда',
  [EContractType.PermTransfer]: 'Переуступка прав аренды',
  [EContractType.ObjSale]: 'Продажа объекта',
};

export const selectContractAdvancedFilter = createSelector(
  [selectContract, selectOfferType, selectOfficeTypes, selectDealType],
  (value, offerType, officeTypes, dealType) => ({
    label: 'Тип договора',
    options: getContractFields(offerType, officeTypes, dealType).map(field => ({ label: LABELS[field], value: field })),
    value: value && value.length > 0 ? value : [null],
  }),
);
